const config = {
    API_URL: "https://api.ficus.su",
  };
  
  export default config;
  